// Import our single shared dependencies here so we ensure everyone uses our version.
// Otherwise, the version will be dictated by the first app to load their version of these.

import "@granular/fabric-core";
import "@granular/fabric-catalog";
import "@granular/fabric-mapbox-tools";
import "@granular/gds-beta";
import "@granular/gds-ux-components";
import "@granular/ag-uom";
import "react";
import "react-dom";
import "react-mapbox-gl";
import "react-router-dom";

// TODO: Do we need to do this for flex dependencies as well?
// It's less than ideal to load all dependencies up front.
